import { Navigate, useParams } from "react-router-dom";

import SurveySectionForm from "@/features/survey/form";

const SurveySection = () => {
  const { surveyId, sectionId } = useParams();

  if (!surveyId || !sectionId) {
    return <Navigate to={"/"} />;
  }

  return (
    <SurveySectionForm
      surveyId={parseInt(surveyId)}
      sectionId={parseInt(sectionId)}
    />
  );
};

export default SurveySection;
